export default __webpack_public_path__ + "static/media/no-artificial-additives-000000.b05ba19d.png";